import DashboardLayout from "../../components/Layout/DashboardLayout";
import ProfileForm from "../../components/User/ProfileForm";

const Profile = () => {
  return (
    <DashboardLayout pageTitle="Profile" mainClass="p-6">
      <div className="flex h-12 nav-bg p-3 text-white font-semibold rounded-tr rounded-tl">
        Edit Profile
      </div>
      <div className="bg-white p-6 rounded-b shadow-md mx-auto">
        <ProfileForm />
      </div>
    </DashboardLayout>
  );
};

export default Profile;
